"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewAnswersProperty = exports.interviewAnswersPropertyDefinition = void 0;
exports.interviewAnswersPropertyDefinition = {
    view: { label: 'Answers' },
    constraints: [
        {
            name: 'properties',
            argument: ['interview-answer'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'interview-answers',
};
const isInterviewAnswersProperty = (prop) => {
    return prop.name === exports.interviewAnswersPropertyDefinition.name;
};
exports.isInterviewAnswersProperty = isInterviewAnswersProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LWFuc3dlcnMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9pbnRlcnZpZXctYW5zd2Vycy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUU7SUFDMUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxrQkFBa0IsQ0FBQztTQUMvQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsbUJBQW1CO0NBQ00sQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9